import { createContext } from '@lit/context';

const WISHLIST_CONTEXT = 'WISHLIST_CONTEXT';
export const wishlistContext = createContext(WISHLIST_CONTEXT);

export default wishlistContext;
